import React from "react";
import { Careers, Footer, Navbar } from "../components";

const Career = () => {
  return (
    <>
      <div className="bg-black w-full">
        <Navbar />
        <Careers />
        <Footer />
      </div>
    </>
  );
};

export default Career;
